$('.js-close-announcement').on('click', function() {
    $(this).closest('.info-banner').slideUp('fast', function() {
        $(this).remove();
    });   

    Cookies.set('hideAnnouncement', 'true', { expires: 30 })
});